import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {getUrlVars} from "../utils/systemInfo";
import {setAddApiKey} from "../store/apiKeySlice";
import OrganizationService from "../api/organization";
import AppService from "../api/app";
import {showMessage} from "../store/messageSlice";
import TemplateAddEdit from "../common/Layout/templatePages/templateAddEdit";

const breadcrumbs = [
    {id: 0, name: "Home", href: "/"},
    {id: 1, name: "Api Keys", href: "/apiKeys"},
    {id: 2, name: "Add/Edit Api Key"}
];

function AddEditApiKey() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const apiKeyForm = useSelector(({addApiKey}) => addApiKey);
    const organization = useSelector(({organziation}) => organziation);
    const api_key_id = String(getUrlVars()["api_key_id"]);
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const isEdit = Boolean(api_key_id && api_key_id !== "undefined");

  useEffect(() => {
        if (isEdit) {
            if (!apiKeyForm?.api_key_id || apiKeyForm?.api_key_id !== api_key_id) {
                setLoading(true);
                const apiKey = organization?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");
                OrganizationService.GetApiKeys(api_key_id, "", "", apiKey).then((json) => {
                    setLoading(false);
                    if (json?.success && json.count > 0) {
                        const data = json.app[0];
                        dispatch(setAddApiKey({
                            ...data,
                            operation_uid: String(data.operation_uid ?? ""),
                            key: String(data.key ?? ""),
                            operation_full_name: String(data.operation_full_name ?? ""),
                            expiry_date: String(data.expiry_date ?? "").split(" ")[0],
                            status: String(data.status ?? "")
                        }));
                    } else {
                        navigate("/apiKeys");
                    }
                });
            }
        } else {
            dispatch(setAddApiKey({
                api_key_id: "",
                operation_full_name: "",
                key: "",
                operation_uid: "",
                expiry_date: "",
                status: "active"
            }));
        }
        // eslint-disable-next-line
    }, [api_key_id, dispatch, isEdit]);

    function handleSave(item) {
        const apiKey = organization?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");
        if (isEdit) {
            AppService.SetApiKey(item.api_key_id, item.operation_uid, item.key, item.expiry_date, item.status, apiKey).then((json) => {
                if (json?.success || json?.data?.success) {
                    dispatch(
                        showMessage({
                            message: t("Saved Successfully"),
                            autoHideDuration: 3000,
                            anchorOrigin: {vertical: "top", horizontal: "center"},
                            variant: "success"
                        })
                    );
                    navigate("/apiKeys");
                } else {
                    dispatch(
                        showMessage({
                            message: t("An error occurred"),
                            autoHideDuration: 3000,
                            anchorOrigin: {vertical: "top", horizontal: "center"},
                            variant: "error"
                        })
                    );
                }
            });
        } else {
            AppService.SetApiKey("", item.operation_uid, "", item.expiry_date, "active", apiKey).then((json) => {
                if (json?.success || json?.data?.success) {
                    dispatch(
                        showMessage({
                            message: t("Saved Successfully"),
                            autoHideDuration: 3000,
                            anchorOrigin: {vertical: "top", horizontal: "center"},
                            variant: "success"
                        })
                    );
                    navigate("/apiKeys");
                } else {
                    dispatch(
                        showMessage({
                            message: t("An error occurred"),
                            autoHideDuration: 3000,
                            anchorOrigin: {vertical: "top", horizontal: "center"},
                            variant: "error"
                        })
                    );
                }
            });
        }
    }

    const addFields = [
        {key: "operation_uid", label: "Organization UID", isRequired: true},
        {key: "expiry_date", label: "Expiry Date", type: "date"}
    ];

    const editFields = [
        {key: "operation_full_name", label: "Organization", isRequired: true},
        {key: "key", label: "API Key", isRequired: true},
        {key: "operation_uid", label: "Organization UID", isRequired: true},
        {key: "expiry_date", label: "Expiry Date", type: "date"},
        {key: "status", label: "Status", isRequired: true, type: "select", options: ["active", "removed"]}
    ];
if (isEdit && (loading || !apiKeyForm?.api_key_id)) {
    return <div>Loading...</div>;
}
return (
    <TemplateAddEdit
        key={apiKeyForm.api_key_id || "add"}
        breadcrumbs={breadcrumbs}
        title={isEdit ? "Edit API Key" : "Add API Key"}
        gridCol={2}
        item={apiKeyForm}
        dataToShow={isEdit ? editFields : addFields}
        onSaveClick={handleSave} 
    />
);}

export default AddEditApiKey;
